



















import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Routes } from '@/router/routes'
import PriceConfig from '@/dto/price_config/PriceConfig'
import Currency from '@/dto/deliveries/Currency'
import DictionariesService from '@/services/DictionariesService'
import PopupMenu from '@/components/price-configs/PopupMenu.vue'

@Component({
  components: { PopupMenu },
})
export default class WeightsTable extends Vue {
  @Prop(Object)
  public props: any

  @Prop(Object)
  public priceConfig: PriceConfig

  get currency(): Currency {
    const currencyCode = this.priceConfig.currencyCode as string
    return DictionariesService.currencies[currencyCode]
  }

  showPriceConfig() {
    const priceConfigId = this.priceConfig.id as number

    if (this.$route.params.priceConfigId !== priceConfigId.toString()) {
      this.$router.push({
        name: Routes.priceConfigEdit,
        params: { priceConfigId: priceConfigId.toString() },
      })
    }
  }
}
